import { ThemeProvider } from "styled-components";
import {
  TabContainer,
  TabsBigContainer,
  TabsContainer,
  TabsRow,
} from "./TabsStyles";
import { token } from "../../theme";
import { useState } from "react";

interface TabsProps {
  items: {
    title: string;
    content: React.ReactNode;
  }[];
}

const Tabs = ({ items }: TabsProps) => {
  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  return (
    <ThemeProvider theme={token}>
      <TabsBigContainer>
        <TabsRow>
          {items.map((tabItem, index) => (
            <TabContainer
              key={tabItem.title}
              onClick={() => {
                setSelectedIndex(index);
              }}
              $selected={selectedIndex === index}
            >
              {tabItem.title}
            </TabContainer>
          ))}
        </TabsRow>
        <TabsContainer>{items[selectedIndex].content}</TabsContainer>
      </TabsBigContainer>
    </ThemeProvider>
  );
};

export default Tabs;
